(function () {
  const getSidebar = () => document.querySelector('[data-article-sidebar][data-sidebar-mode="products"]');
  const getOverlay = () => document.querySelector('[data-article-offers-overlay]');
  const getPreview = () => document.querySelector('[data-active-product-preview]');
  const getPreviewContent = () => document.querySelector('[data-active-product-preview-content]');
  const getProductCards = () => Array.from(document.querySelectorAll('.article-template__sidebar[data-sidebar-mode="products"] .article-product-card[data-product-gid]'));
  const mobileMq = window.matchMedia('(max-width: 989px)');

  const getActiveCard = () => getProductCards().find((card) => card.classList.contains('is-active')) || null;

  const syncPreview = () => {
    const preview = getPreview();
    const previewContent = getPreviewContent();
    const sidebar = getSidebar();
    if (!preview || !previewContent) return;

    if (!mobileMq.matches || !sidebar || sidebar.classList.contains('is-open')) {
      preview.hidden = true;
      previewContent.innerHTML = '';
      return;
    }

    const activeCard = getActiveCard();
    if (!activeCard) {
      preview.hidden = true;
      previewContent.innerHTML = '';
      return;
    }

    previewContent.innerHTML = activeCard.outerHTML;
    preview.hidden = false;
  };

  const open = () => {
    const sidebar = getSidebar();
    const overlay = getOverlay();
    if (!sidebar) return;
    sidebar.classList.add('is-open');
    if (overlay) {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
    }
    document.body.classList.add('article-offers-open');
    syncPreview();
  };

  const close = () => {
    const sidebar = getSidebar();
    const overlay = getOverlay();
    if (sidebar) sidebar.classList.remove('is-open');
    if (overlay) {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('article-offers-open');
    syncPreview();
  };

  document.addEventListener('click', (e) => {
    const preview = e.target.closest('[data-active-product-preview]');
    if (preview && !e.target.closest('a, button, input, select, textarea, form, article-cart-add')) {
      e.preventDefault();
      open();
      return;
    }

    const toggle = e.target.closest('[data-article-offers-toggle]');
    if (toggle) {
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-article-offers-close]')) {
      e.preventDefault();
      close();
      return;
    }
    if (e.target.matches('[data-article-offers-overlay]')) {
      close();
    }
  });

  document.addEventListener('keyup', (e) => {
    const sidebar = getSidebar();
    if (e.key === 'Escape' && sidebar && sidebar.classList.contains('is-open')) close();
  });

  const observeActiveCard = () => {
    const cards = getProductCards();
    if (!cards.length) {
      syncPreview();
      return;
    }

    const observer = new MutationObserver(() => {
      syncPreview();
    });

    cards.forEach((card) => {
      observer.observe(card, { attributes: true, attributeFilter: ['class'] });
    });

    syncPreview();
  };

  const desktopMq = window.matchMedia('(min-width: 990px)');
  const handleDesktopMQ = (e) => {
    if (e.matches) close();
    else syncPreview();
  };
  if (desktopMq.addEventListener) desktopMq.addEventListener('change', handleDesktopMQ);
  else if (desktopMq.addListener) desktopMq.addListener(handleDesktopMQ);

  if (mobileMq.addEventListener) mobileMq.addEventListener('change', syncPreview);
  else if (mobileMq.addListener) mobileMq.addListener(syncPreview);

  observeActiveCard();
})();
